module.exports = __webpack_public_path__ + "img/dundrum_1.f3127fff.webp";